import { useMainHeaderOverrides } from '@/components/MainHeader/contexts/Overrides'
import { ColorEnum } from '@/constants/color'
import IconButton from '@/features/ui/buttons/components/IconButton'
import CloseIcon from '@/features/ui/icons/components/CloseIcon'
import { useIsFocused } from '@react-navigation/native'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface UseMapPanelHeaderOverridesOptions {
    enabled: boolean
    onClose: () => void
}

export const useMapPanelHeaderOverrides = ({
    enabled,
    onClose,
}: UseMapPanelHeaderOverridesOptions) => {
    const { t } = useTranslation()
    const focused = useIsFocused()

    const visible = enabled && focused

    const overrides = useMemo(
        () =>
            visible
                ? {
                      title: t('ordersMap.title'),
                      left: null,
                      right: (
                          <IconButton
                              Icon={() => <CloseIcon fill={ColorEnum.WHITE} />}
                              onPress={onClose}
                              accessibilityRole="button"
                              accessibilityLabel={t('actions.close')}
                          />
                      ),
                  }
                : undefined,
        [onClose, t, visible]
    )

    useMainHeaderOverrides(overrides)
}
